import styled from 'styled-components';
export const Head_1 = styled.h1`
  font-size: 5.2rem;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 1px;
  color: #ffffff;
`;
export const Head_2 = styled.h2`
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: 1px;
`;
export const Head_3 = styled.h3`
  font-weight: 700;
  font-size: 2.2rem;
  line-height: 1.2;
  margin: 35px 0px;
  color: var(--color-tertiary);
  margin-bottom: ${(props) => props.marginBottom};
`;
export const Head_5 = styled.h5`
  margin-left: 1.5em;
  font-size: 1.85rem;
  font-weight: 400;
  color: rgb(119, 119, 119);
`;
export const Highlight = styled.span`
  border-bottom: 3px dashed;
  padding-bottom: 0.3em;
  color: var(--color-highlight);
  padding-right: 0.625em;
`;

export const Para = styled.p`
  line-height: 2;
  font-size: 1.5rem;
  width: 100%;
  animation-name: none;
  margin-bottom: 45px;
  font-weight: 400;
  color: var(--color-text);
`;
export const Shadow = styled.span`
  position: absolute;
  top: -28px;
  left: 112px;
  font-weight: 800;
  font-size: 7rem;
  z-index: -1;
  color: var(--color-shadow);
`;
